// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

export * as app from './app';
export { AppStartContext } from './hooks/AppStartContext';
export { AppTerminateContext } from './hooks/AppTerminateContext';
export { HookContext } from './hooks/HookContext';
export { InvocationHookContext } from './hooks/InvocationHookContext';
export { LogHookContext } from './hooks/LogHookContext';
export { PostInvocationContext } from './hooks/PostInvocationContext';
export { PreInvocationContext } from './hooks/PreInvocationContext';
export { HttpRequest } from './http/HttpRequest';
export { HttpResponse } from './http/HttpResponse';
export * as input from './input';
export { InvocationContext } from './InvocationContext';
export { promptArg } from './mcp/McpPromptArgumentBuilder';
export {
    McpAudioContent,
    McpContentBlock,
    McpImageContent,
    McpResourceContent,
    McpResourceLinkContent,
    McpTextContent,
    McpToolResponse,
} from './mcp/McpToolResponse';
export { PromptInvocationContext } from './mcp/PromptInvocationContext';
export * as output from './output';
export * as trigger from './trigger';
export { Disposable } from './utils/Disposable';
export { McpContent } from './utils/mcpContentMarker';
export { arg } from './utils/toolProperties';

export enum SqlChangeOperation {
    Insert = 0,
    Update = 1,
    Delete = 2,
}

export enum MySqlChangeOperation {
    Update = 0,
}
